module.exports = __webpack_public_path__ + "img/document.825dc967.svg";